import misc from './misc';

/**
 * Slider
 * @constructor
 * @requires pubsub-js
 */
class Slider {

  constructor(){

    this.init = this.init.bind(this);

    this.init();

  }

  init( dom ){

    dom = dom || document;

    this.sliders = dom.qsa('[data-slider]');

    this.sliders.forEach(function(slider){

      var config = JSON.parse(slider.dataset.slider);

      if( config['pagination'] ){
        config.pagination = {
          el: slider.querySelector('.swiper-pagination'),
          clickable: true,
          renderBullet: function (index, className) {
            return '<li class="' + className + '"><span>' + (index + 1) + '</span></li>';
          }
        }
      }

      if(config['breakpoints'] && config['isProduct']){
        config.breakpoints = {
          767: {
            slidesPerView: 2,
            spaceBetween: 10,
            noSwiping: false,
            allowSlidePrev: true,
			      allowSlideNext: true
          },
          9999: {
            slidesPerView: auto,
            spaceBetween: 20,
            noSwiping: true,
            allowSlidePrev: false,
			      allowSlideNext: false
          }
        }
      } 

      if( config['navigation'] ){
        config.navigation = {
          nextEl: '.bt-slider.next',
          prevEl: '.bt-slider.prev',
        }
      }

      if( config['navigation-full-height'] ){
        config.navigation = {
          nextEl: '.custom-button.next',
          prevEl: '.custom-button.prev',
        }
      }

      config.on = {};

      config.on.init = function(){
        if( this.isBeginning && this.isEnd ){
          slider.classList.add('all-visible');
        }

        if( slider.querySelector('.swiper-slide-active iframe') ){
          misc.youtubeAutoplay( slider.querySelector('.swiper-slide-active iframe'));
          slider.classList.add('playing');
        }

        // /**
        //  * Fix bug from comparator
        //  */
        // if (this.config.loop && (this.slides.length - 2) < this.config.slidesPerView) {
        //   this.slidesPerView = this.slides.length - 2;
        //   this.destroy(false, false);
        //   this.init();
        // }
      };
      config.on.slideChange = function(){
        const slides = slider.qsa('.swiper-slide');

        // stop youtube playing
        slides.forEach((slide)=>{
          if( slide.querySelector('iframe') ){
            misc.youtube( slide.querySelector('iframe'), 'stopVideo');
            misc.youtubeStopSlider( slide.querySelector('iframe'), slider);
            slider.classList.remove('playing');
          }
        });

        // autoplay youtube
        if( slider.querySelector('.swiper-slide-active iframe') && config.autovideo ){
          misc.youtubeApi( slider.querySelector('.swiper-slide-active iframe'));
          slider.classList.add('playing');
        }

        // update external pager
        if( slider.sliderDom && config.external ){
          const controls = slider.closest('[data-slider-ct]').qsa('[data-slideTo]');
          controls.forEach( (control) => {
            control.classList.remove('active');
          });
          const currentSlide = slider.closest('[data-slider-ct]').querySelector('[data-slideTo="' + parseInt(slider.sliderDom.realIndex+1,10) + '"]');
          if( currentSlide ){
            currentSlide.classList.add('active');
          }

        }
      }
      config.on.resize = function(swiper){
        if( this.isBeginning && this.isEnd ){
          slider.classList.add('all-visible');
        }
        else{
          slider.classList.remove('all-visible');
        }
      }

      slider.sliderDom = new Swiper(slider, config);

      if( config.autoplay ){
        document.addEventListener('visibilitychange', function(){
          if( document.hidden ){
            slider.sliderDom.autoplay.stop();
          }
          else{
            slider.sliderDom.autoplay.start();
          }
        });
      }

    });

    var controls = document.querySelector('[data-slider-controls]');

    if( !controls || (!!controls && !controls.querySelector('[data-slideTo]')) ){
      return;
    }
    controls.qsa('[data-slideTo]').forEach( (control) => {

      control.addEventListener('click', function(e){

        e.preventDefault();

        var trigger = e.currentTarget,
            slide = +trigger.dataset.slideto,
            slider = trigger.closest('[data-slider-ct]').querySelector('[data-slider]');

        slider.sliderDom.slideTo(slide);
        controls.querySelector('.active').classList.remove('active');
        control.classList.add('active');

      });

    });
  }
}

export default new Slider();
